import React from "react";
import PropTypes from "prop-types";

const Search = ({ onSearchChange, value }) => (
  <div className="search-wrapper">
    <input type="text" placeholder="Search by name or city..." onChange={e => onSearchChange(e)} value={value} />
  </div>
);

Search.propTypes = {
  onSearchChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default Search;
